import * as React from "react";
const SvgRedWarning = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#f3676b", d: "m7.137 2.5-5.5 9.5a1 1 0 0 0 .863 1.5h11a1 1 0 0 0 .862-1.5l-5.5-9.5a.994.994 0 0 0-1.725 0", style: {
  fill: "#f3676b",
  fill: "color(display-p3 .9529 .4039 .4196)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", d: "M8 6.5V9", style: {
  stroke: "#fff",
  strokeOpacity: 1
} }), /* @__PURE__ */ React.createElement("path", { fill: "#fff", stroke: "#fff", strokeWidth: 0.083, d: "M8.708 11.25a.708.708 0 1 1-1.416 0 .708.708 0 0 1 1.416 0Z", style: {
  fill: "#fff",
  fillOpacity: 1,
  stroke: "#fff",
  strokeOpacity: 1
} }));
export default SvgRedWarning;
